<template>
  <div class="flex justify-center">
    <a href="#" class="bg-black py-4 px-6 uppercase"
      ><router-link to="/">Return to shop</router-link></a
    >
  </div>
</template>
<script>
export default {
  name: "ReturnHome",
};
</script>